import React, {useEffect, useMemo, useRef} from 'react'
import styled, { css } from 'styled-components';

const RichTextDiv = styled.div`
  ${props => !props.className && css`
    font-size: 13px;
  `}
  div {
    min-height: 16px; 
  }
  p {
    min-height: 16px;
    margin: 0;
  }
  .frame-object{
    min-height: 0px;
  }
  ul, ol {
    display: block;
    list-style-type: disc;
    margin-top: 0;
    margin-bottom: 0;
    margin-left: 0;
    margin-right: 0;
    padding-left: 30px;
  }
  ol {
    list-style-type: decimal;
  }
  ol[data-is-first],ul[data-is-first] {
    margin-top: 0.5rem;
  }
  ol[data-is-last],ul[data-is-last] {
    margin-bottom: 0.5rem;
  }
  blockquote {
    margin: 0 0 0 40px;
    border: none;
    padding: 0px;
  }
  blockquote.blockquote-list {
    margin: 0 0 0 30px;
    border: none;
    padding: 0px;
  }
  label {
    display: block;
    font-weight: 600;
    margin-bottom: 0.25rem;
  }
  ${props => props.withMargins && css`
    margin: 0.5rem 0.5rem 2rem 0.5rem;
  `}
  ${props => props.className && props.className.indexOf('overview') >= 0 && css`
    font-size: 14px !important;
    p {
      min-height: 16px;
      font-size: 14px;
      margin: 0;
    }
    .frame-object{
      min-height: 0px;
    }
    table-content div{
      font-size: 14px;
    }
  `}
  
`

export function safeMultipleNewLineToBr(str) {
  // By replace \n into <br/> line breaks will be displayed on RichText input Fields and PDF Reports
  return (str||"").replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/\n/g,'<br/>')
}
const addSrc = (content,getResource) => {
  try {
    // Parse the HTML content safely
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, "text/html");

    // Fix all <img> elements (images)
    doc.querySelectorAll("img").forEach(img => {
      try {
        if (img.dataset.uid) {
          img.crossOrigin = 'anonymous';
          img.src = getResource(img.dataset.uid)
        }
      } catch (innerError) {
        console.warn("Error processing image:", img.outerHTML, innerError);
      }
    });

    // Return the modified HTML as a string
    return doc.body.innerHTML;
  } catch (error) {
    console.error("Error processing HTML content:", error);
    return content; // Return original content if an error occurs
  }
}
function fixAccessibleContent(content,getResource) {
  try {
      // Parse the HTML content safely
      const parser = new DOMParser();
      const doc = parser.parseFromString(content, "text/html");

      // Fix all <img> elements (images)
      doc.querySelectorAll("img").forEach(img => {
          try {
            if (img.dataset.uid) {
              img.crossOrigin = 'anonymous';
              img.src = getResource(img.dataset.uid)
            }
              if (!img.hasAttribute("alt") || img.getAttribute("alt").trim() === "") {
                  img.setAttribute("alt", "Report content image");
              }
              if (!img.hasAttribute("role")) {
                  img.setAttribute("role", "img");
              }
              if (!img.hasAttribute("aria-hidden")) {
                  img.setAttribute("aria-hidden", "false");
              }
          } catch (innerError) {
              console.warn("Error processing image:", img.outerHTML, innerError);
          }
      });

      // Return the modified HTML as a string
      return doc.body.innerHTML;
  } catch (error) {
      console.error("Error processing HTML content:", error);
      return content; // Return original content if an error occurs
  }
}

export const RichTextDisplay = React.memo(({content, className, useSafeNewLine = false, getResource}) => {
  const ref = useRef()
  const html = useMemo(() => (useSafeNewLine
    ? addSrc(safeMultipleNewLineToBr(content),getResource)
    : fixAccessibleContent(content,getResource)).replace(/<p><\/p>$/,""),
    [content]
  )
  return <RichTextDiv
    ref={ref}
    className={className}
    dangerouslySetInnerHTML={{ __html: html }}
  />
}, (prevProps, nextProps) => {
  return prevProps.content === nextProps.content && prevProps.className === nextProps.className
})